import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as profileApi from "./profileApi";

export const fetchUserProfileThunk = createAsyncThunk(
  "profile/FETCH_USER_PROFILE",
  async (_, { rejectWithValue }) => {
    try {
      const response = await profileApi.fetchUserProfile();
      if (!response.data?.success) {
        rejectWithValue(response.data);
      }
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
);

export const selectProfileLastFetched = state => state.profile.lastFetched;

const profileSlice = createSlice({
  name: "profile",
  initialState: { isLoading: false, error: null, lastFetched: null },
  reducers: {
    SET_PROFILE: (_state, action) => {
      return { ...action.payload, isLoading: false, error: null };
    },
    SET_LAST_LOGIN: state => {
      state.last_logged_in_time = new Date().toUTCString();
    },
    REMOVE_PROFILE: (state, action) => {
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserProfileThunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchUserProfileThunk.fulfilled, (_, action) => {
        return {
          ...action.payload,
          isLoading: false,
          error: null,
          lastFetched: Date.now(),
        };
      })
      .addCase(fetchUserProfileThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || action.payload?.error;
      });
  },
});

export const { SET_PROFILE, SET_LAST_LOGIN, REMOVE_PROFILE } =
  profileSlice.actions;

export default profileSlice.reducer;
